module.exports = __webpack_public_path__ + "media/images/modules/root_on_talkport/mask_group-96c582a3c432bf89cb1d7aa19c1df64a.png";